const mediaItems = [
  {
    title: '暗夜追踪 第二季 精彩预告',
    desc: '悬疑升级，真相浮出水面。西瓜视频免费高清全集在线观看。',
    duration: '02:35',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20noir%20atmosphere%20with%20warm%20amber%20streetlights%20and%20soft%20shadows%2C%20mysterious%20urban%20night%20scene%2C%20elegant%20film%20noir%20lighting%2C%20no%20text%2C%20editorial%20quality%2C%20warm%20coral%20and%20dark%20tones%2C%20cinematic%20composition&width=600&height=340&seq=media-1-dark&orientation=landscape',
  },
  {
    title: '欢乐喜剧人 爆笑集锦',
    desc: '笑点密集全程高能，本季最搞笑的十个瞬间一次看过瘾。',
    duration: '05:12',
    views: '96万',
    image: 'https://readdy.ai/api/search-image?query=Bright%20warm%20stage%20lighting%20with%20colorful%20spotlights%20and%20abstract%20celebration%20atmosphere%2C%20joyful%20entertainment%20vibe%2C%20soft%20golden%20and%20coral%20tones%2C%20no%20text%2C%20editorial%20quality%2C%20energetic%20composition&width=600&height=340&seq=media-2-comedy&orientation=landscape',
  },
  {
    title: '仙道至尊 第48话 决战篇',
    desc: '主角突破境界，与宿敌展开惊天对决。丝瓜视频同步更新中。',
    duration: '22:08',
    views: '85万',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20fantasy%20abstract%20with%20flowing%20energy%20streams%20and%20warm%20golden%20particles%2C%20epic%20atmosphere%2C%20coral%20and%20amber%20gradients%2C%20no%20text%2C%20cinematic%20lighting%2C%20high%20detail%20editorial%20style&width=600&height=340&seq=media-3-anime&orientation=landscape',
  },
  {
    title: '蓝色星球III 深海探秘',
    desc: '潜入万米深海，探访未曾见过的神秘生物与瑰丽海底世界。',
    duration: '48:20',
    views: '73万',
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20deep%20ocean%20abstract%20with%20soft%20blue-green%20gradients%20and%20flowing%20light%20beams%2C%20mysterious%20underwater%20atmosphere%2C%20elegant%20organic%20shapes%2C%20no%20text%2C%20editorial%20quality%2C%20cinematic%20lighting&width=600&height=340&seq=media-4-ocean&orientation=landscape',
  },
  {
    title: '经典港片 英雄本色 回顾',
    desc: '重温周润发、狄龙经典之作，港片黄金年代的不朽传奇佳话。',
    duration: '04:50',
    views: '62万',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20Hong%20Kong%20street%20scene%20with%20warm%20neon%20lights%20and%20rain-slicked%20pavement%2C%20vintage%20cinema%20atmosphere%2C%20soft%20golden%20and%20coral%20tones%2C%20film%20grain%20texture%2C%20no%20text%2C%20artistic%20composition&width=600&height=340&seq=media-5-hk&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            精彩看点
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选热门影视精彩片段与预告，快速了解最热内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-background-300/80 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/15 group-hover:bg-black/25 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 bg-black/60 backdrop-blur-sm rounded-md px-2 py-1 text-xs text-background-50">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 mb-1.5 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-2">{item.desc}</p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}